// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as TitleCmp$PorterinFeature from "../../auto-complete/TitleCmp.mjs";
import * as NextImage$PorterinFeature from "../../../../../../ui/components/NextImage.mjs";
import * as IconTitleCmpModuleScss from "../styles/IconTitleCmp.module.scss";

var styles = IconTitleCmpModuleScss;

function IconTitleCmp(Props) {
  var close_modal = Props.close_modal;
  var icon = Props.icon;
  var title = Props.title;
  return React.createElement("div", {
              className: styles.container,
              onClick: (function (param) {
                  Curry._1(close_modal, undefined);
                })
            }, React.createElement(NextImage$PorterinFeature.make, {
                  src: icon.src,
                  height: icon.height,
                  width: icon.width,
                  quality: 80.0,
                  alt: icon.alt
                }), React.createElement(TitleCmp$PorterinFeature.make, {
                  title: title,
                  class_name: styles.title
                }));
}

var make = IconTitleCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
